import { useNavigate } from 'react-router-dom';

import { routes } from '~/shared/config/routes';
import { cn } from '~/shared/lib/cn';
import { useIsMobile } from '~/shared/lib/hooks';
import { Button } from '~/shared/ui/button';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '~/shared/ui/hover-card';
import { Popover, PopoverContent, PopoverTrigger } from '~/shared/ui/popover';

import { LogoutButton } from '~/features/authorization/logout';

type Properties = React.HTMLAttributes<HTMLDivElement>;

export function UserSectionHoverCard({ className, children }: Properties) {
  const navigate = useNavigate();
  const isMobile = useIsMobile(1280);

  if (isMobile) {
    return (
      <Popover>
        <PopoverTrigger asChild>{children}</PopoverTrigger>
        <PopoverContent
          align="center"
          className={cn(
            'mr-4 mt-2 flex w-56 flex-col gap-2 bg-background',
            className,
          )}
        >
          <Button
            width="full"
            variant="secondary"
            onClick={() => navigate(routes.dashboard.myProfile.get())}
          >
            My Profile
          </Button>
          <LogoutButton />
        </PopoverContent>
      </Popover>
    );
  }

  return (
    <HoverCard>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent
        className={cn(
          'mr-4 mt-2 flex w-56 flex-col gap-2 bg-background',
          className,
        )}
      >
        <Button
          width="full"
          variant="secondary"
          onClick={() => navigate(routes.dashboard.myProfile.get())}
        >
          My Profile
        </Button>
        <LogoutButton />
      </HoverCardContent>
    </HoverCard>
  );
}
